import { styled } from '@mui/material/styles';
import VpLink from '../VpLink';

const svgStyles = {
  height: '18px',
  width: '18px',
  padding: '0px'
};

export const StyledVpLink = styled(VpLink)(({ theme }) => ({
  color: theme.palette.vpColors.greyDark,
  ...svgStyles,
  svg: {
    color: theme.palette.vpColors.greyDark,
    ...svgStyles
  }
}));



// WEBPACK FOOTER //
// ./src/vp-ui/components/NavMenuIcons/styles.js